import React from 'react'
import { useTranslation } from 'react-i18next'

const PrivacyPolicy = () => {
    const { t } = useTranslation()

    return (
        <section className="py-100">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="content-wrapper">
                            <h2 className="text-center mb-40">{t('footer.privacyPolicy')}</h2>
                            <div className="mb-32">
                                <h4 className="mb-16">1. Information We Collect</h4>
                                <p className="mb-8">We collect personal information that you voluntarily provide to us when you register on our website, place an order, subscribe to our newsletter, respond to a survey, fill out a form, or otherwise contact us.</p>
                                <p>The personal information we collect may include your name, email address, postal address, phone number, payment information, and other details to help us provide you with a better experience.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">2. How We Use Your Information</h4>
                                <p className="mb-8">We use the information we collect to:</p>
                                <ul className="mb-8 list-disc pl-24">
                                    <li>Process transactions and send related information including confirmations and invoices</li>
                                    <li>Send you promotional communications, which you can opt out of at any time</li>
                                    <li>Respond to your comments, questions, and customer service requests</li>
                                    <li>Develop and improve our products, services, marketing, and user experience</li>
                                    <li>Protect against, identify, and prevent fraud and other unlawful activity</li>
                                </ul>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">3. Information Sharing and Disclosure</h4>
                                <p className="mb-8">We do not sell or rent your personal information to third parties. We may share your information with:</p>
                                <ul className="mb-8 list-disc pl-24">
                                    <li>Service providers who help us operate our business and provide you with services</li>
                                    <li>Law enforcement or other parties when required by law or to protect our rights</li>
                                    <li>Business partners with your consent or when you have chosen to share information</li>
                                </ul>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">4. Cookies and Tracking Technologies</h4>
                                <p className="mb-8">We use cookies and similar tracking technologies to track activity on our website and to hold certain information to improve your experience.</p>
                                <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our site.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">5. Data Security</h4>
                                <p className="mb-8">We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
                                <p>However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">6. Your Rights</h4>
                                <p className="mb-8">Depending on your location, you may have certain rights regarding your personal information, including:</p>
                                <ul className="mb-8 list-disc pl-24">
                                    <li>The right to access the personal information we have about you</li>
                                    <li>The right to request that we correct or update incorrect or incomplete information</li>
                                    <li>The right to request that we delete your personal information</li>
                                    <li>The right to withdraw consent to our processing of your information</li>
                                </ul>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">7. Children's Privacy</h4>
                                <p>Our website is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.</p>
                            </div>
                            <div>
                                <h4 className="mb-16">8. Changes to This Privacy Policy</h4>
                                <p className="mb-8">We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the effective date.</p>
                                <p>We recommend that you review this Privacy Policy periodically for any changes.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PrivacyPolicy 